import { concatMap, defaultIfEmpty, filter, from, Observable, take, timer } from 'rxjs';
import { GeneratedReport } from '@/bag/bag-transport-term/bag-transport-term.model';

export const EMPTY_REPORT_STATUS = 'EE';
export const REPORT_POLL_INTERVAL_MS = 3000;
export const REPORT_MAX_POLL_ATTEMPTS = 60;

/**
 * Polls an asynchronously generated report until it is finished, empty or the attempt limit is reached.
 * A report is finished only when {@link GeneratedReport.url} is a non-empty string.
 *
 * @param getReport - Function fetching the current state of the report.
 * @returns Observable emitting the finished/empty {@link GeneratedReport} once, or `null` when the report
 * could not be fetched or was not ready within {@link REPORT_MAX_POLL_ATTEMPTS} attempts.
 */
export function pollGeneratedReport(getReport: () => Promise<GeneratedReport>): Observable<GeneratedReport | null> {
	return timer(0, REPORT_POLL_INTERVAL_MS).pipe(
		take(REPORT_MAX_POLL_ATTEMPTS),
		concatMap(() => from(getReport())),
		filter((report) => !report || report.status === EMPTY_REPORT_STATUS || !!report.url),
		take(1),
		defaultIfEmpty(null),
	);
}
